export default {
  en: {
    nav: {
      home: 'HOME',
      product: 'PRODUCT',
      kitchen: 'KITCHEN',
      living: 'LIVING',
      dining: 'DINING',
      bedroom: 'BEDROOM',
      showroom: 'SHOWROOM',
      partners: 'PARTNERS',
      news: 'NEWS',
      aboutUs: 'ABOUT US',
      contact: 'CONTACT'
    },
    hero: {
      bespoke: 'BESPOKE',
      wardrobe: 'WARDROBE'
    },
    about: {
      paragraph1: '<strong>VIDA</strong> was born from over 30 years of design experience under <a href="https://www.finest.com.hk/en/"> <strong>FINEST </strong></a>, a company founded in 1992 and trusted by architects, developers, and commercial clients for high-quality office furniture.',
      paragraph2: 'In 2016, we launched <a href="https://finestdesignnest.com/"><strong> FINEST DESIGN NEST</strong></a> — a creative hub and co-working space where ideas were shared, tested, and refined among designers and professionals.',
      paragraph3: '<strong>VIDA</strong> stands at the pinnacle of craftsmanship and design, drawing from decades of experience in creating furniture of uncompromising quality. We elevate cabinets and wardrobes into vessels of refined artistry, where precision craftsmanship and understated elegance merge seamlessly. Each piece is imbued with intent—seamless joinery, exquisite finishes, and meticulously selected materials converge to shape living spaces that frame daily rituals with enduring grace and timeless sophistication.',
      paragraph4: 'Building on this dedication, <strong>VIDA</strong> extends its ethos through partnership with <a href="https://gaggenau.kih.com.hk/tc"><strong> Gaggenau</strong></a>, the world‑renowned appliance brand. Together, <strong>VIDA</strong> and <a href="https://gaggenau.kih.com.hk/tc"><strong> Gaggenau</strong></a> shape and transform daily living into an effortless harmony of function and form.',
      finestCaption: 'Finest since 1992 ',
      designNestCaption: 'Finest Design Nest since 2016 '
    },
    contact: {
      title: 'VIDA',
      subtitle: 'LIVING',
      officeShowroom: 'Office & Showroom',
      address: 'G/F, 121-123 Chatham Rd South<br />Tsim Sha Tsui, Hong Kong',
      phone: 'Phone',
      whatsapp: 'WhatsApp',
      fax: 'Fax',
      email: 'Email',
      website: 'www.vidaliving.com.hk',
      getInTouch: 'Get in touch',
      form: {
        name: 'Name',
        phone: 'Phone',
        email: 'Email',
        message: 'Message',
        send: 'Send'
      }
    },
    dialog: {
      image: 'Image'
    },
    news: {
      title: 'VIDA NEWS',
      headline: '[2025 Autumn Home Living Expo] Exclusive Preview: Debut of Our New Bespoke Collection',
      paragraph: 'We are thrilled to announce the debut of our new bespoke collections, featuring wardrobes, kitchen cabinets, and display cabinets. These pieces will officially launch at our Tsim Sha Tsui showroom after the exhibition. Each piece embodies our commitment to bespoke living, refined artistry, craftsmanship and elegance, seamless joinery, exquisite finishes, and meticulously selected materials.',
      exhibitionDetails: 'Exhibition Details',
      venue: 'Venue',
      venueName: 'Hong Kong Convention and Exhibition Centre (HKCEC)',
      booth: 'Booth',
      boothNumber: '5D-M30',
      dateTime: 'Date & Time',
      date1: '26 Sep (Fri) 10:00-21:00',
      date2: '27 Sep (Sat) 10:00-21:00',
      date3: '28 Sep (Sun) 10:00-19:00'
    },
    showroom: {
      title: 'VIDA SHOWROOM',
      heroAlt: 'VIDA Showroom hero',
      intro: 'VIDA, A Legacy of Craftsmanship and Innovation.',
      intro2: 'Where design meets life, VIDA is born. A celebration of bespoke living, it transforms cabinetry and wardrobes into expressions of refined artistry, where precision and subtle elegance are inseparable.',
      intro3: 'Each creation flows with intent seamless joinery, exquisite finishes, and meticulously selected materials converge to shape spaces that move with life, framing daily rituals with enduring grace and timeless sophistication.',
      feature1: {
        title: 'GLASS<br />SLIDING DOORS',
        description: 'This sliding door design is the ultimate synergy of material and craftsmanship:',
        description2: 'Texture Interpretation ： Crafted with premium matte spray - paint finish — boasting a dense, silky - s mooth, flawless surface. Paired with custom precision - engineered aluminum framing, its sleek, crisp lines exude understated yet distinguished metallic elegance. T he monolithic visual aesthetic is minimalist, yet inherently radiates a luxurious, refined amb iance.',
        description3: 'Design Philosophy ： Featuring a concealed recessed track system at the top: it entirely eliminates the cluttered look of exposed traditional tracks, enhancing the space ’ s sense of transparency and neatness. Meanwhile, it achieves a seamless, tight sea l when the two doors close — weaving the human - centric vision of "invisible aesthetics" and "precision functionality" into every detail of its meticulous refinement.',
        readMore: ''
      }
    },
    partners: {
      title: 'VIDA PARTNERS',
      heroAlt: 'VIDA partners banner',
      intro: '',
      logoAlt: 'Partner logo',
      cards: [
        {
          name: 'Atelier E: <a href="https://www.ateliere.co">www.ateliere.co</a>',
          description: "With over 25 years of experience in architecture and interior design, Enoch Hui, the founder of Atelier E, has cultivated a distinctive design philosophy that infuses every project with its own unique character. He views each undertaking as a symphony of interconnected spaces, marked by refined details that invite a journey of discovery. Enoch's approach emphasizes the importance of curiosity in design; instead of adhering to specific styles or trends, he believes that true cre ativity is born from a sense of wonder and exploration.",
          logoAlt: 'Partner logo 1',
          logo: ''
        },
        {
          name: 'GAGGENAU: <a href="https://gaggenau.kih.com.hk/tc">www.gaggenau.kih.com.hk/tc</a>',
          description: 'As connoisseurs of quality in bespoke furniture design, we are honoured to welcome GAGGENAU into our partnership. A titan of premium German kitchen appliances founded in 1683, GAGGENAU combines exquisite craftsmanship and avant-garde design in equal measure, cementing its status as an iconic staple in high-end kitchen spaces.',
          description2: 'From built-in ovens to top-tier cooktops, GAGGENAU’s products are far more than high-performance appliances—they are the understated aesthetic centerpiece of bespoke furniture design. Boasting a sleek metallic finish and clean, minimalist lines, these appliances blend seamlessly with bespoke cabinetry in modern, minimalist or even luxurious styles. They not only cater to the needs of professional culinary enthusiasts, but also elevate the overall visual coherence and sophistication of bespoke furniture setups.',
          description3: 'Visit its official website to explore how this century-old brand, rooted in decades of heritage, redefines the aesthetic boundaries between kitchen spaces and daily life. This, in essence, is the core vision behind our collaboration with GAGGENAU: to deliver bespoke furniture spaces that achieve the perfect synergy of functionality and aesthetic excellence for our clients.',
          logoAlt: 'Partner logo 2',
          logo: ''
        },
        {
          name: 'DeRUCCI: <a href="https://global.derucci.com/">https://global.derucci.com/</a>',
          description: 'Founded in 2004, DeRUCCI pioneers sleep wellness with a mission to help people sleep better. It integrates ergonomic science, AI, and international design aesthetics to deliver personalized, high-end sleep solutions. Supported by over 5,300 stores globally, Industry 4.0 manufacturing, and a five-star service system, DeRUCCI (SZSE: 001323) provides exceptional experiences as a trusted, long-term partner for clients and design collaborators.',
          logoAlt: 'Partner logo 3',
          logo: ''
        },
        {
          name: 'Kiyoshi Okada: <a href="https://www.artfromocean.com">https://www.artfromocean.com</a>',
          description: '“I have been creating artworks from my own underwater photos which were taken when I was diving. For a long time, I had a desire to do something creative and artistic. ',
          description2: 'During the Covid pandemic, I could not go anywhere for diving. During the time, I experimented to make artworks from my underwater photos. No other divers have been doing this kind of thing. I just experimented and did not know what I was doing and where I was going. I frequently stunned by the images appeared on  my PC screen with surprise and excitement. This is the reason why I kept doing this creation. ',
          description3: 'Marine creatures are attractive, especially the colors and patterns on their bodies. These colors and patterns are inspiring to make artworks. Mother Nature is an artist, I ﬁrmly believe. ',
          description4: 'It is my great honor that my artworks become parts of high-end furnitures. It is my privilege to see my artwork to become a part of these furnitures, and have a precious opportunity to present my artworks to the public',
          description5: 'Please visit my home page, artfromocean.com, to see what I explored, created and enjoyed.” ',
          description6: '',
          logoAlt: 'Partner logo 4',
          logo: ''
        },
        {
          name: 'Nam Nam – A Taste of Sweden in Hong Kong',
          description: 'Step into a world of color, flavor, and joy with Nam Nam, the Swedish candy brand bringing vibrant confectionery traditions to Hong Kong. Every piece of Nam Nam candy bursts with playful hues and irresistible taste, crafted to delight both the eye and the palate.',
          description2: 'Founded with a vision to connect cultures, Nam Nam bridges the sweetness of Swedish heritage with the dynamic spirit of Hong Kong. We believe candy is more than a treat—it is a symbol of celebration, togetherness, and tradition. In Sweden, candy holds a cherished place at holidays and family gatherings, marking moments of joy and community. Nam Nam carries this legacy forward, offering Hong Kong a chance to savor the same festive spirit.',
          description3: 'Quality is at the heart of everything we do. From sourcing ingredients to perfecting recipes, we ensure every bite reflects the excellence of Swedish confectionery. Our colorful assortment embodies the artistry and care that generations of Swedish candy makers have celebrated.',
          description4: 'Nam Nam is more than candy—it is a cultural connection, a sweet invitation to share happiness across borders. Discover the flavors of Sweden, right here in Hong Kong, and let Nam Nam brighten your celebrations.',
          logoAlt: 'Partner logo 5',
          logo: ''
        }
      ]
    }
  },
  zh: {
    nav: {
      home: '首頁',
      product: '產品',
      kitchen: '廚房',
      living: '客廳',
      dining: '飯廳',
      bedroom: '睡房',
      news: '新聞',
      showroom: '陳列室',
      partners: '合作伙伴',
      aboutUs: '關於我們',
      contact: '聯絡我們'
    },
    hero: {
      bespoke: '訂製',
      wardrobe: '衣櫃'
    },
    about: {
      paragraph1: '<strong>VIDA</strong> 源自 <a href="https://www.finest.com.hk/en/"> <strong>FINEST </strong></a>三十餘年的設計沉澱。自 1992 年創立以來，<strong>FINEST </strong>以卓越工藝與精緻辦公家具，贏得建築師、開發商及商業客戶的長久信賴。',
      paragraph2: '2016 年，我們創立 <a href="https://finestdesignnest.com/ "><strong>FINEST DESIGN NEST</strong> </a>—— 一座兼具共享辦公功能與創意薈萃的殿堂，設計師們在此交流構想，淬煉每一份靈感，將創意轉化為實際的設計成果。',
      paragraph3: '<strong>VIDA</strong>  立於工藝與設計的巔峰，承襲數十年精湛家具製作經驗，將櫥櫃與衣櫃昇華為兼具功能與藝術之作。每件作品皆蘊含設計理念——精準工藝、仔細打磨、嚴選材質，勾勒出生活空間的每一個細節，將日常化為持久優雅與恆久品味。',
      paragraph4: '秉持對極致美學與完美工藝的追求，<strong>VIDA</strong> 與世界頂級家電品牌 <a href="https://gaggenau.kih.com.hk/tc"><strong> Gaggenau</strong></a> 攜手合作，將生活空間轉化為功能與美學的和諧統一，締造日常的至臻體驗。',
      finestCaption: 'Finest 自 1992 年',
      designNestCaption: 'Finest Design Nest 自 2016 年'
    },
    contact: {
      title: 'VIDA',
      subtitle: 'LIVING',
      officeShowroom: '辦公室及陳列室',
      address: '香港九龍<br />尖沙咀漆咸道南<br />121-123號地下',
      phone: '電話',
      whatsapp: 'WhatsApp',
      fax: '傳真',
      email: '電郵',
      website: 'www.vidaliving.com.hk',
      getInTouch: '聯絡我們',
      form: {
        name: '姓名',
        phone: '電話',
        email: '電郵',
        message: '訊息',
        send: '發送'
      }
    },
    dialog: {
      image: '圖片'
    },
    news: {
      title: 'VIDA 新聞',
      headline: '【2025 秋季居家生活博覽】 尊享預覽｜全新訂製系列首度亮相',
      paragraph: '率先一睹我們最新訂製系列的風采——包括衣櫃、廚櫃及展示櫃。展覽後，這些精心策劃的作品將於尖沙咀展廳正式上市。每一件創作都彰顯訂製生活美學，將功能空間昇華為精緻藝術的呈現。體驗工藝與優雅完美融合的設計：無縫接合、精緻表面處理，以及精心甄選材質所帶來的細膩美感',
      exhibitionDetails: '【展覽詳情】',
      venue: '展覽地點',
      venueName: '香港會議展覽中心 (HKCEC)',
      booth: '展位號碼',
      boothNumber: '5D-M30',
      dateTime: '日期及時間',
      date1: '26 九月 (週五) 10:00-21:00',
      date2: '27 九月 (週六) 10:00-21:00',
      date3: '28 九月 (週日) 10:00-19:00'
    },
    showroom: {
      title: 'VIDA SHOWROOM',
      heroAlt: 'VIDA Showroom hero',
      intro: 'VIDA：匠心傳承，創新不止。',
      intro2: '當設計邂逅生活，VIDA應運而生。品牌執著於個性化定制家居體驗，將櫥櫃衣櫥化作精緻藝術臻品，讓精工質感與低調奢華完美交融。',
      intro3: '每一件作品皆蘊藏匠心巧思——嚴絲合縫的拼接工藝、細膩考究的表面處理、甄選優質的原生材質，諸多優勢融為一體，打造出與生活同頻的靈動空間，以經典優雅的格調，定格每一個日常儀式感瞬間。',
      feature1: {
        title: 'GLASS<br />SLIDING DOORS',
        description: '這組趟門的設計，是材質與工藝的極致契合:',
        description2: '質感詮釋：選用高級霧面噴漆工藝，漆面緻密細膩，觸感絲滑無瑕；搭配訂製級精工鋁框，線條洗練利落，金屬質感低調而矜貴，一體式視覺簡約卻自帶奢雅氛圍。',
        description3: '設計哲思：門頂採用隱藏式嵌入式軌道機構——徹底摒棄傳統軌道外露的凌亂感，讓空間層次更顯通透整潔；同時實現雙門閉合時的嚴絲合縫，將「美學隱形」與「功能精準」的人性化考量，藏進每一寸細節的極致打磨裡。',
        readMore: ''
      }
    },
    partners: {
      title: 'VIDA PARTNERS',
      heroAlt: 'VIDA partners banner',
      intro: '',
      logoAlt: 'Partner logo',
      cards: [
        {
          name: 'Atelier E: <a href="https://www.ateliere.co">www.ateliere.co</a>',
          description: '擁有超過 25 年的建築和室內設計經驗， Atelier E 的創辦人許諾培養了一種獨特的設計哲學，讓每 個項目都展現出其獨特的魅力。他將每個項目視為一場互連空間的交響曲，以獨特的設計細節引 導人們展開探索之旅。許諾的設計理念強調好奇心的重要性；他認為真正的創造力源於對生活的 好奇和探索，而不是遵循特定的設計風格或趨勢。',
          logoAlt: 'Partner logo 1',
          logo: ''
        },
        {
          name: 'GAGGENAU: <a href="https://gaggenau.kih.com.hk/tc">www.gaggenau.kih.com.hk/tc</a>',
          description: '作為訂製傢俬設計領域的品質追求者，我們很榮幸將 GAGGENAU 納入合作品牌陣容。這位誕生於 1683 年的德國頂級廚電巨匠，以「極致工藝 + 前衛設計」的雙重基因，成為高端廚房空間的標配符號。',
          description2: '從嵌入式烤箱到頂級灶具，GAGGENAU 的產品不僅是功能強大的廚電，更是訂製傢俬設計中「隱形的美學核心」—— 其低調質感的金屬質感、精簡線條，能與定製櫥櫃的現代、極簡乃至奢華風格完美嵌合，既滿足專業廚藝需求，又能讓訂製傢俬的整體視覺更具統一性與高級感。',
          description3: '訪問其官網（https://gaggenau.kih.com.hk/tc），即可窺見這一品牌如何以百年積澱，重新定義「廚房與生活的美學邊界」—— 而這，也正是我們與 GAGGENAU 合作的初衷：為客戶打造「功能與美感雙極致」的訂製傢俬空間。',
          logoAlt: 'Partner logo 2',
          logo: ''
        },
        {
          name: '慕思: <a href="https://global.derucci.com/">https://global.derucci.com/</a>',
          description: '作為健康睡眠解決方案的引領者，慕思（DeRUCCI）始於2004年，堅守「讓人們睡得更好」的使命。品牌透過融合人體工學、AI科技與國際美學，提供個人化的高端睡眠產品與服務。基於全球5,300餘家門店、工業4.0智造及五星服務體系，慕思（深交所：001323）不僅確保每位用戶獲得卓越體驗，更致力於成為設計夥伴與客戶最值得信賴的長期選擇。',
          logoAlt: 'Partner logo 3',
          logo: ''
        },
        {
          name: 'Kiyoshi Okada: <a href="https://www.artfromocean.com">https://www.artfromocean.com</a>',
          description: '“我的藝術創作，源於潛水時親自拍攝的海底攝影作品。長久以來，我一直渴望開啟一段兼具創意與藝術性的探索之旅。',
          description2: '新冠疫情期間，潛水計劃被迫擱淺，我便開始嘗試將這些海底攝影素材轉化為藝術作品。這是一條無人踏足的創作徑路，一開始我毫無章法，只是憑著熱忱不斷摸索。每當電腦屏幕上誕生出獨特的畫面，驚喜與激動便會席捲而來 —— 也正是這份悸動，驅使著我堅持創作至今。',
          description3: '海洋生物渾身充滿誘人魅力，尤其是它們體表絢麗的色彩與獨特的紋理，皆為藝術創作帶來無限靈感。我始終篤信，大自然才是最頂級的藝術大師。',
          description4: '能讓自己的作品走進高端傢具領域，成為傢具設計的一部分，於我而言是莫大的榮幸。更珍貴的是，我得以藉此契機，向大眾展示這些誕生於深海的藝術創想。',
          description5: '歡迎造訪我的個人主頁 artfromocean.com，領略我在深海藝術領域的探索、創作與熱愛。”',
          description6: '',
          logoAlt: 'Partner logo 4',
          logo: ''
        },
        {
          name: 'Nam Nam —— 喺香港，邂逅瑞典嘅甜',
          description: '走進 Nam Nam 的繽紛世界，盡享色彩、風味與歡樂。這一瑞典糖果品牌，正將活力滿滿的歐式糖果傳統帶到香港。每一粒 Nam Nam 糖果，都裹藏著俏皮絢麗的色彩與難以抗拒的滋味，從視覺到味蕾，全方位帶來歡愉體驗。',
          description2: '品牌誕生之初，便以文化交融為初心。Nam Nam 締結起瑞典傳統甜點的醇正風味，與香港的多元活力精神。在我們看來，糖果從不只是一份甜點，更是慶典的象徵、相聚的見證，以及傳統的延續。在瑞典，糖果是節慶與家庭聚會中不可或缺的存在，見證著每一個歡樂共享的溫馨時刻。如今，Nam Nam 將這份甜蜜傳承帶到香港，讓這座城市也能品嚐到同款的節日歡欣。',
          description3: '品質是我們的立身之本。從精選原料到匠心研發配方，每一個環節都精益求精，確保每一口都蘊含瑞典糖果製作的卓越工藝。我們的繽紛糖果陣容，凝萃了數代瑞典糖果匠人堅守的匠心與藝術感。',
          description4: 'Nam Nam 不僅是糖果，更是一條文化紐帶，一份跨越山海的甜蜜邀約，邀你共享歡樂時光。不必遠赴歐洲，在香港就能邂逅地道瑞典風味，讓 Nam Nam 為你的每一次慶典，增添一抹亮麗甜韻。',
          logoAlt: 'Partner logo 5',
          logo: ''
        }
      ]
    }
  },
  cn: {
    nav: {
      home: '首页',
      product: '产品',
      kitchen: '橱柜',
      living: '客厅',
      dining: '饭厅',
      bedroom: '卧室',
      news: '新闻',
      showroom: '陈列室',
      partners: '合作伙伴',
      aboutUs: '关于我们',
      contact: '联系我们'
    },
    hero: {
      bespoke: '定制',
      wardrobe: '衣柜'
    },
    about: {
      paragraph1: '<strong>VIDA</strong> 源自 <a href="https://www.finest.com.hk/en/"> <strong>FINEST </strong></a>三十余年的设计沉淀。自 1992 年创立以来，<strong>FINEST </strong>以卓越工艺与精致办公家具，赢得建筑师、开发商及商业客户的长期信赖。',
      paragraph2: '2016 年，我们创立 <a href="https://finestdesignnest.com/ "><strong>FINEST DESIGN NEST</strong> </a>—— 一座兼具共享办公功能与创意荟萃的殿堂，设计师们在此交流构想，淬炼每一份灵感，将创意转化为实际的设计成果。',
      paragraph3: '<strong>VIDA</strong> 立于工艺与设计的巅峰，承袭数十年精湛家具制作经验，将橱柜与衣柜升华为兼具功能与艺术之作。每件作品皆蕴含设计理念——精准工艺、仔细打磨、严选材质，勾勒出生活空间的每一个细节，将日常化为持久优雅与恒久品味。',
      paragraph4: '秉持对极致美学与完美国艺的追求，<strong>VIDA</strong> 与世界顶级家电品牌 <a href="https://gaggenau.kih.com.hk/tc"><strong> Gaggenau</strong></a> 携手合作，将生活空间转化为功能与美学的和谐统一，缔造日常的至臻体验。',
      finestCaption: 'Finest 自 1992 年',
      designNestCaption: 'Finest Design Nest 自 2016 年'
    },
    contact: {
      title: 'VIDA',
      subtitle: 'LIVING',
      officeShowroom: '办公室及陈列室',
      address: '香港九龙<br />尖沙咀漆咸道南<br />121-123号地下',
      phone: '电话',
      whatsapp: 'WhatsApp',
      fax: '传真',
      email: '邮箱',
      website: 'www.vidaliving.com.hk',
      getInTouch: '联系我们',
      form: {
        name: '姓名',
        phone: '电话',
        email: '邮箱',
        message: '信息',
        send: '发送'
      }
    },
    dialog: {
      image: '图片'
    },
    news: {
      title: 'VIDA 新闻',
      headline: '【2025 秋季居家生活博览】 尊享预览｜全新定制系列首度亮相',
      paragraph: '率先一睹我们最新定制系列的风采——包括衣柜、橱柜及展示柜。展览后，这些精心策划的作品将于尖沙咀展厅正式上市。每一件创作都彰显定制生活美学，将功能空间升华为精致艺术的呈现。体验工艺与优雅完美融合的设计：无缝接合、精致表面处理，以及精心甄选材质所带来的细腻美感。',
      exhibitionDetails: '【展览详情】',
      venue: '展览地点',
      venueName: '香港会议展览中心 (HKCEC)',
      booth: '展位号码',
      boothNumber: '5D-M30',
      dateTime: '日期及时间',
      date1: '9月26日(周五) 10:00-21:00',
      date2: '9月27日(周六) 10:00-21:00',
      date3: '9月28日(周日) 10:00-19:00'
    },
    showroom: {
      title: 'VIDA SHOWROOM',
      heroAlt: 'VIDA Showroom hero',
      intro: 'VIDA：匠心传承，创新不止。',
      intro2: '当设计邂逅生活，VIDA应运而生。品牌执着于个性化定制家居体验，将橱柜衣柜化作精致艺术臻品，让精工质感与低调奢华完美交融。',
      intro3: '每一件作品皆蕴藏匠心巧思——严丝合缝的拼接工艺、细腻考究的表面处理、甄选优质的原生材质，诸多优势融为一体，打造出与生活同频的灵动空间，以经典优雅的格调，定格每一个日常仪式感瞬间。',
      feature1: {
        title: 'GLASS<br />SLIDING DOORS',
        description: '这组趟门的设计，是材质与工艺的极致契合:',
        description2: '质感诠释：选用高级雾面喷漆工艺，漆面致密细腻，触感丝滑无瑕；搭配定制级精工铝框，线条洗练利落，金属质感低调而矜贵，一体式视觉简约却自带奢雅氛围。',
        description3: '设计哲思：门顶采用隐藏式嵌入式轨道机构——彻底摒弃传统轨道外露的凌乱感，让空间层次更显通透整洁；同时实现双门闭合时的严丝合缝，将「美学隐形」与「功能精准」的人性化考量，藏进每一寸细节的极致打磨里。',
        readMore: ''
      }
    },
    partners: {
      title: 'VIDA PARTNERS',
      heroAlt: 'VIDA partners banner',
      intro: '',
      logoAlt: 'Partner logo',
      cards: [
        {
          name: 'Atelier E: <a href="https://www.ateliere.co">www.ateliere.co</a>',
          description: '拥有超过 25 年的建筑和室内设计经验， Atelier E 的创办人许诺培养了一种独特的设计哲学，让每 个项目都展现出其独特的魅力。他将每个项目视为一场互连空间的交响曲，以独特的设计细节引 导人们展开探索之旅。许诺的设计理念强调好奇心的重要性；他认为真正的创造力源于对生活的 好奇和探索，而不是遵循特定的设计风格或趋势。',
          logoAlt: 'Partner logo 1',
          logo: ''
        },
        {
          name: 'GAGGENAU 官方网站: <a href="https://gaggenau.kih.com.hk/tc">www.gaggenau.kih.com.hk/tc</a>',
          description: '作为定制家具设计领域的品质追求者，我们很荣幸将 GAGGENAU 纳入合作品牌阵容。这位诞生于 1683 年的德国顶级厨电巨匠，以 "极致工艺 + 前卫设计" 的双重基因，成为高端厨房空间的标配符号。',
          description2: '从嵌入式烤箱到顶级灶具，GAGGENAU 的产品不仅是功能强大的厨电，更是定制家具设计中 "隐形的美学核心"—— 其低调质感的金属质感、精简线条，能与定制橱柜的现代、极简乃至奢华风格完美嵌合，既满足专业厨艺需求，又能让定制家具的整体视觉更具统一性与高级感。',
          description3: '访问其官网（https://gaggenau.kih.com.hk/tc），即可窥见这一品牌如何以百年积淀，重新定义 "厨房与生活的美学边界"—— 而这，也正是我们与 GAGGENAU 合作的初衷：为客户打造 "功能与美感双极致" 的定制家具空间。',
          logoAlt: 'Partner logo 2',
          logo: ''
        },
        {
          name: '慕思 官方网站: <a href="https://global.derucci.com/">https://global.derucci.com/</a>',
          description: '作为健康睡眠解决方案的引领者，慕思（DeRUCCI）始于 2004 年，坚守「让人们睡得更好」的使命。品牌通过融合人体工学、AI 科技与国际美学，提供个人化的高端睡眠产品与服务。基于全球 5,300 余家门店、工业 4.0 智造及五星服务体系，慕思（深交所：001323）不仅确保每位用户获得卓越体验，更致力于成为设计伙伴与客户最值得信赖的长期选择。',
          logoAlt: 'Partner logo 3',
          logo: ''
        },
        {
          name: 'Kiyoshi Okada: <a href="https://www.artfromocean.com">https://www.artfromocean.com</a>',
          description: '“我的艺术创作，源于潜水时亲自拍摄的海底摄影作品。长久以来，我一直渴望开启一段兼具创意与艺术性的探索之旅。',
          description2: '新冠疫情期间，潜水计划被迫搁浅，我便开始尝试将这些海底摄影素材转化为艺术作品。这是一条无人踏足的创作径路，一开始我毫无章法，只是凭着热忱不断摸索。每当电脑屏幕上诞生出独特的画面，惊喜与激动便会席卷而来 —— 也正是这份悸动，驱使着我坚持创作至今。',
          description3: '海洋生物浑身充满诱人魅力，尤其是它们体表绚丽的色彩与独特的纹理，皆为艺术创作带来无限灵感。我始终笃信，大自然才是最顶级的艺术大师。',
          description4: '能让自己的作品走进高端家具领域，成为家具设计的一部分，于我而言是莫大的荣幸。更珍贵的是，我得以借此契机，向大众展示这些诞生于深海的艺术创想。',
          description5: '欢迎造访我的个人主页 artfromocean.com，领略我在深海艺术领域的探索、创作与热爱。”',
          description6: '',
          logoAlt: 'Partner logo 4',
          logo: ''
        },
        {
          name: 'Nam Nam —— 在香港，邂逅瑞典的甜',
          description: '走进 Nam Nam 的缤纷世界，尽享色彩、风味与欢乐。这一瑞典糖果品牌，正将活力满满的欧式糖果传统带到香港。每一粒 Nam Nam 糖果，都裹藏着俏皮绚丽的色彩与难以抗拒的滋味，从视觉到味蕾，全方位带来欢愉体验。',
          description2: '品牌诞生之初，便以文化交融为初心。Nam Nam 缔结起瑞典传统甜点的醇正风味，与香港的多元活力精神。在我们看来，糖果从不只是一份甜点，更是庆典的象征、相聚的见证，以及传统的延续。在瑞典，糖果是节庆与家庭聚会中不可或缺的存在，见证着每一个欢乐共享的温馨时刻。如今，Nam Nam 将这份甜蜜传承带到香港，让这座城市也能品尝到同款的节日欢欣。',
          description3: '品质是我们的立身之本。从精选原料到匠心研发配方，每一个环节都精益求精，确保每一口都蕴含瑞典糖果制作的卓越工艺。我们的缤纷糖果阵容，凝萃了数代瑞典糖果匠人坚守的匠心与艺术感。',
          description4: 'Nam Nam 不仅是糖果，更是一条文化纽带，一份跨越山海的甜蜜邀约，邀你共享欢乐时光。不必远赴欧洲，在香港就能邂逅地道瑞典风味，让 Nam Nam 为你的每一次庆典，增添一抹亮丽甜韵。',
          logoAlt: 'Partner logo 5',
          logo: ''
        }
      ]
    }
  }
}
